<template>
  <div class="live-conversation">
    <header class="live-inner-header">
      <div class="live-header-info">
        <div class="live-header-name">
          <span class="sub">
            {{$parent.actualRoom.client_number}}
          </span>
          <span v-if="$parent.actualRoom.status === 'scheduled'" class="live-status badge badge-success">
            Agendado
          </span>
          <span v-if="$parent.actualRoom.status === 'send'" class="live-status badge badge-success">
            Enviado
          </span>
          <!-- <span class="live-status global" v-else-if="$parent.currentRoom.parentRoomId.indexOf('global') !== -1">Finalizado</span> -->
          <span v-else-if="$parent.actualRoom.status === 'in_progress'" class="live-status badge badge-info">Em progresso</span>
          <span v-else-if="$parent.actualRoom.status === 'canceled'" class="live-status badge badge-danger">Cancelado</span>
        </div>
        <div ref="contactEmail" class="d-flex align-items-center live-header-contact">
          <div class="flex-grow-1">
            {{ $parent.actualRoom.scheduled_at | formatUtc }}
          </div>
        </div>
      </div>
      <div class="live-header-tools --d-flex" v-if="$parent.actualRoom.status !== 'send'">
        <button class="btn btn-danger btn-common" @click="cancelSchedule" style="margin-right: 5px;">
          Cancelar
        </button>
        <button class="btn btn-primary btn-common" @click="reSchedule">
          Reagendar
        </button>
      </div>
    </header>
    <div style="width: 50%;">
      <PreviewTemplate :template="$parent.actualRoom.template" />
    </div>
    <div class="card bg-white footer-message" v-if="$parent.actualRoom.status !== 'send'">
      <template v-if="$parent.actualRoom.template">
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div>
              <ButtonComponent variant="tertiary" @click="openWhatsappTemplates">
                <span class="material-icons-outlined text-success">
                  lightbulb
                </span>
                Alterar Template
              </ButtonComponent>
              <div class="vr"></div>
              <ButtonComponent
                v-if="$parent.actualRoom.template.header && $parent.actualRoom.template.header.type !== 'TEXT'"
                variant="secondary" class="m-r-20" @click="changeImage">
              <span class="material-icons-outlined">
                image
              </span>
                Alterar Cabeçalho
              </ButtonComponent>
              <ButtonInputComponent
                v-for="(variable, i) in $parent.actualRoom.template.params"
                :key="i"
                class="param-button m-r-20"
                variant="secondary"
                v-model="$parent.actualRoom.template.params[i]"
              >
                <template #prepend>
                  <span class="material-icons-outlined">
                    data_object
                  </span>
                </template>
                Adicionar parâmetro {{ i + 1 }}
              </ButtonInputComponent>

            </div>
            <div>
              <ButtonComponent variant="tertiary" @click="updateTemplate">
                <span class="material-icons-outlined">
                  save
                </span>
              </ButtonComponent>
            </div>
          </div>
        </div>
        <SidebarComponent ref="whatsapp-templates" title="Selecionar Template">
          <WhatsappTemplateSelectComponent ref="whatsapp-template-select" @changeNumber="changeSender"></WhatsappTemplateSelectComponent>
          <template #footer>
            <div class="d-flex align-items-center px-3 py-2">
              <ButtonComponent variant="secondary" class="mr-auto" @click="$refs['whatsapp-templates'].toggle()">Cancelar
              </ButtonComponent>
              <ButtonComponent @click="selectWhatsappTemplate">Confirmar</ButtonComponent>
            </div>
          </template>
        </SidebarComponent>
        <template v-if="$parent.actualRoom.template">
          <FileUploadComponent v-if="$parent.actualRoom.template.header" ref="import-media"
                              @import="changeMedia"
                              :format="$parent.actualRoom.template.header.type"></FileUploadComponent>
        </template>
      </template>
      <div v-if="isSending" class="loading text-center text-primary my-2">
        <span aria-hidden="true" class="align-middle spinner-border">
        </span>
      </div>
      <SidebarComponent ref="reschedule-sidebar" title="Reagendar" >
        <div class="row">
          <div class="col-sm-12"><br></div>
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-6">
                <label>Data</label>
                <Calendar v-model="newDate" @input="changeSchedule" showIcon iconDisplay="input" dateFormat="dd/mm/yy" />
              </div>
              <div class="col-sm-6">
                <label>Horas</label>
                <Calendar v-model="newDate" @input="changeSchedule" showIcon iconDisplay="input" timeOnly />
              </div>
            </div>
            <br>
            <br>
          </div>
        </div>
        <template #footer>
          <div class="d-flex align-items-center px-3 py-2">
            <ButtonComponent @click="reScheduleAction">Confirmar</ButtonComponent>
          </div>
        </template>
      </SidebarComponent>
    </div>
  </div>
</template>

<script>

import axios from '@/plugins/axios';

import PreviewTemplate from '@/components/rebranding/whatsappj/PreviewTemplate.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import ButtonInputComponent from '@/components/form/ButtonInputComponent.vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import WhatsappTemplateSelectComponent from '@/components/whatsappj/TemplateSelectComponent.vue';
import FileUploadComponent from '@/components/form/FileUploadComponent.vue';
import Calendar from 'primevue/calendar';
import moment from 'moment';
import Swal from 'sweetalert2';

const webApi = axios();

export default {
  name: 'Conversation',
  components: {
    PreviewTemplate,
    ButtonComponent,
    ButtonInputComponent,
    SidebarComponent,
    WhatsappTemplateSelectComponent,
    FileUploadComponent,
    Calendar,
  },
  props: ['openedWhatsappTemplate'],
  data() {
    return {
      isSending: false,
    };
  },
  mounted() {
  },
  computed: {
    newDate() {
      return new Date(this.$parent.actualRoom.scheduled_at);
    },
  },
  beforeDestroy() {
  },
  watch: {
  },
  methods: {
    cancelSchedule() {
      Swal.fire({
        title: 'Cancelar agendamento',
        text: 'Tem certeza que deseja cancelar',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (!result.value) return;
        webApi.delete(`/scheduleroom/${this.$parent.actualRoom.id}`).then(() => {
          this.isSending = false;
          this.$toast.show({
            title: this.$t('app.success'),
            content: 'Agendamento cancelado',
            type: 'success',
          });
          this.$parent.currentRoom = null;
          this.$parent.scheduledsRoom();
        })
          .catch((error) => {
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.response.data.code}`,
              content: error.response.data.message,
              type: 'danger',
            });
          })
          .finally(() => {
            this.updating = false;
          });
      });
    },
    changeSchedule(date) {
      this.$parent.actualRoom.scheduled_at = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm');
    },
    selectWhatsappTemplate(template) {
      if (this.$refs['whatsapp-template-select'].selectedTemplate) {
        this.$parent.actualRoom.template = this.$refs['whatsapp-template-select'].selectedTemplate;

        const variables = this.$parent.actualRoom.template.body.text.match(/{{[0-9]}}/g);
        if (variables) {
          this.$parent.actualRoom.template.params = Array(this.$parent.actualRoom.template.body.text.match(/{{[0-9]}}/g).length);
        }
        this.$refs['whatsapp-templates'].hide();
      } else {
        this.$toast.show({
          title: 'Erro',
          content: 'É necessário adicionar um template',
          type: 'danger',
        });
      }
    },
    changeSender(sender) {
      this.$parent.actualRoom = sender;
    },
    changeImage() {
      this.$refs['import-media'].open();
    },
    changeMedia(mediaUrl) {
      this.$parent.actualRoom.template.header.example_parameter = mediaUrl;
    },
    updateTemplate() {
      this.isSending = true;
      webApi.put(`/scheduleroom/${this.$parent.actualRoom.id}`, {
        scheduled_at: this.$parent.actualRoom.scheduled_at,
        channel: 'whatsapp-java',
        agent_id: this.$parent.actualRoom.agent_id,
        sender: this.$parent.actualRoom.sender,
        client_number: this.$parent.actualRoom.recipient,
        template: this.$parent.actualRoom.template,
      }).then(() => {
        this.isSending = false;
        this.$toast.show({
          title: this.$t('app.success'),
          content: 'Dados atualizados',
          type: 'success',
        });
      })
        .catch((error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.response.data.code}`,
            content: error.response.data.message,
            type: 'danger',
          });
        })
        .finally(() => {
          this.updating = false;
        });
    },
    openWhatsappTemplates() {
      this.$refs['whatsapp-templates'].show();
    },
    reSchedule() {
      this.$refs['reschedule-sidebar'].show();
    },
    reScheduleAction() {
      this.$refs['reschedule-sidebar'].hide();
      this.updateTemplate();
    },
  },
};
</script>

<style lang="scss" scoped>
.whatsapp-meta-component {
  &::v-deep {
    .card {
      margin-bottom: 0 !important;
    }

    .main {
      padding: 0 !important;

      & > .mt-3 {
        margin-top: 0 !important;
      }

      & > .my-4 {
        border: none !important;
        margin: 0 !important;
        margin-bottom: 3px !important;
      }
    }
  }
}

.omni-transcript.today {
  .omni-transcript-header {
    display: none;
  }
}

.omni-transcript {
  & + .omni-transcript.today .omni-transcript-header {
    display: block;
  }
}

.omni-transcript-header {
  position: sticky;
  z-index: 90;
  top: -1rem;
  // left: 50%;
  // top: 0;
  // transform: translateX(-50%);
  text-align: center;
  margin: 0 auto;
  pointer-events: none;

  & > .card {
    pointer-events: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 2.5rem !important;
    display: inline-block;
    font-size: 0.72rem;
    font-weight: bold;
    padding: 0.2rem 0.6rem;
  }

  .dot {
    display: inline-block;
    vertical-align: middle;
    border-radius: 0.4rem;
    margin: 0 0.25rem;
    background-color: #752de6;
    width: 0.4rem;
    height: 0.4rem;
  }
}

.material-icons-outlined {
  color: #788db4 !important;
}

.whatsapp-bg {
  background: #efeae2 url('/assets/img/chat-bg.png');
  margin: 1.25rem -1.25rem;
  padding: 1rem;
  pointer-events: none;
}

.whatsapp-message {
  display: inline-block;
  max-width: 65%;
  min-width: 224px;
}

.whatsapp-preview {
  margin: 0 0 0.1rem 0;

  & > p {
    margin: 0;
  }
}

.qt-loader {
  text-align: center;
  padding: 32px;
}

.recording-write {
  text-align: center;

  &::v-deep .spinner-grow {
    margin: 0 0.22em;
  }
}

.live-inner-header {
  border-bottom: thin solid rgba(0, 0, 0, 0.08);

  .live-header-info {
    padding-left: 1rem;
    height: 100%;
  }
}

.live-resume-contact {
  margin-top: 1em;

  &::v-deep > .card > .tabs {
    .tab-content {
      overflow: auto;
      height: 100%;
      max-height: 350px;
    }

    & > .card-header {
      padding-bottom: 0;

      & > .nav {
        margin-bottom: 0;
      }
    }
  }
}

.live-header-contact {
  margin-top: 0.32rem;
  font-size: 0.8rem;

  &.current {
    display: flex !important;
  }
}

.live-media-preview {
  background: transparent;
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0;

  video {
    background: #333;
  }

  & > * {
    pointer-events: none;
    min-height: 16px;
    min-width: 16px;
    display: block;
  }
}

.live-conversation {
  display: flex;
  width: calc(100% - 30px);
  height: calc(100% - 30px);
  margin: 10px 0 0 15px;
  flex-direction: column;
  position: relative;
}

.live-old-load {
  padding: 1em;
  text-align: center;
}

.live-transcript {
  position: relative;
  height: calc(100% - 172px);
  overflow: hidden;
  overflow-y: auto;

  &.readonly,
  &.live-transcript-old {
    height: calc(100% - 80px);
    background: url('data:image/svg+xml,%3Csvg width="220px" height="220px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">%3Cg fill="%23eee">%3Cpath fill="none" d="M0 0H24V24H0z"/>%3Cpath d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8C9.25 4 6.824 5.387 5.385 7.5H8v2H2v-6h2V6c1.824-2.43 4.729-4 8-4zm1 5v4.585l3.243 3.243-1.415 1.415L11 12.413V7h2z"/>%3C/g>%3C/svg>')
      bottom right no-repeat;
  }
}

.live-transcript-old + .live-transcript {
  height: 0 !important;
  padding: 0 !important;
}

.live-manager-actions {
  position: relative;
  height: 92px;
  text-align: right;

  &.live-resume-actions {
    width: 204px;
    position: absolute;
    bottom: 0;
    right: 0.5em;
    z-index: 1000;
  }

  width: 204px;
  position: absolute;
  bottom: 0;
  right: 0.5em;

  .live-manager-enter {
    color: #fff;
    background-color: #752de6;
    padding: 1em 2em;
    border-radius: 0.2rem;
    border: none;
    font-size: 9pt;
    display: block;
    width: 98%;
    height: 40px;
    white-space: nowrap;

    & ~ .live-manager-enter {
      margin-top: 0.3em;
    }

    &,
    i,
    .material-icons-outlined {
      vertical-align: middle;
    }

    i,
    .material-icons-outlined {
      font-size: 1.2rem;
      margin-right: 0.5em;
      color: #fff !important;
    }
  }
}

.live-input {
  // display: flex;
  // flex-direction: row;
  // flex-wrap: nowrap;
  // justify-content: space-between;
  // align-content: normal;
  // align-items: center;
  border: thin solid #e5e5e5;
  background: #fff;
  padding: 0 0.5em;
  position: relative;
  z-index: 90;

  .tools-by-channel {
    height: 45px;
  }

  .tools {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-content: normal;
    align-items: center;
    // border-top: thin solid #eee;
  }

  .material-icons-outlined {
    font-size: 1.3rem;
  }

  // @media (max-width: 800px) {
  //   width: 100%;
  //   position: fixed;
  //   bottom: 0;
  //   left: 0;
  // }

  & > * {
    display: block;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: 40px;
    align-self: auto;
    order: 0;
    height: 45px;

    @media (max-width: 480px) {
      flex-basis: 45px;
    }
  }

  .live-file-preview {
    position: absolute;
    z-index: 90;
    left: -0.6rem;
    bottom: 1rem;
    width: calc(100% + 1.2em);
    height: 60vh;
    max-height: 640px;
    // margin: 0;
    // border: 0;
    // border-radius: 0;
    // background: #fff;
    // border: 0 solid #e8e4e4;
    // border-top-width: thin;
    // box-shadow: 0 -31px 31px -22px rgba(0,0,0,.2);

    aside {
      min-width: 200px;

      img,
      audio,
      video {
        display: block;
        margin: 0 auto;
      }
    }

    &.live-record-audio {
      z-index: 91;
      bottom: -3rem;

      .record {
        text-align: center;

        .timer {
          font-size: 9pt;
        }

        .audio-finish {
          margin: 10px 0;
          border-radius: 48px;
          background: #f00;
          border: none;
          height: 92px;
          width: 92px;
          font-size: 32pt;
          box-shadow: 0 0 0 rgba(0, 0, 0, 0.02), 0 0 0 0 rgba(0, 0, 0, 0.06);
          animation-duration: 0.4s;
          animation-name: audioWave;
          animation-iteration-count: infinite;
          animation-direction: alternate;

          i,
          & {
            color: #fff !important;
          }

          @keyframes audioWave {
            from {
              box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.02), 0 0 0 0 rgba(0, 0, 0, 0.06);
            }

            to {
              box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.2), 0 0 0 4px rgba(0, 0, 0, 0.2);
            }
          }
        }

        footer {
          font-size: 7pt;
        }

        .row {
          padding: 20px 0;
        }

        .row > div {
          padding: 0;
        }

        .audio-cancel,
        .audio-send {
          width: 100%;
        }
      }
    }

    .card-header {
      height: 72px;

      button {
        background: transparent;
        border: none;
        padding: 0;

        i {
          font-size: 16pt;
        }
      }
    }

    .card-body {
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100% - 72px);
      position: relative;

      aside {
        img,
        object,
        video {
          position: relative;
          border: thin solid #e8e4e4;
          object-fit: contain;
          height: 100%;
          max-height: 240px;

          @media (max-height: 500px) {
            max-height: 150px;
          }

          @media (max-height: 420px) {
            max-height: 110px;
          }
        }

        .d-flex {
          @media (max-height: 420px), (max-width: 240px) {
            font-size: 8pt;
          }
        }
      }
    }
  }

  .live-file-preview-meta {
    font-size: 9pt;
  }
}

.live-input-out {
  flex-grow: 1;
  flex-basis: auto;
  // height: 52px;
  // padding: 0 12px;
  // margin: 0 12px;
  height: auto !important;
}

.live-input {
  // background: #f7f7f7;
  background: #fff;
  // margin: 0 1.2em;
  margin: 0;
  border-radius: 0.2rem;
  margin-top: 20px;

  ::v-deep button > span,
  ::v-deep button > i {
    display: block;
  }

  .window-create-sample-msg {
    position: absolute;
    left: 0.32rem;
    bottom: 0.82rem;
    background: #fff;
    width: 420px;

    .window-create-sample-close {
      border: none;
      border-radius: 20px;
      background: #000;
      position: absolute;
      right: -15px;
      top: -15px;
      width: 32px;
      height: 32px;

      i {
        color: #fff;
      }
    }

    h1 {
      font-size: 12pt;
    }

    & > .relative {
      position: relative;
      padding: 0.7rem;
    }

    .qt-block-ui {
      position: absolute !important;
    }
  }

  .btn-create-sample-msg {
    background: transparent !important;
    border: none !important;
    height: auto !important;
    // position: absolute;
    // right: 0;
    // top: 0;
    padding: 0.62rem 0.2rem;
    width: 100% !important;
    height: 100% !important;

    // i {
    //   color: #fff;
    // }

    & + textarea {
      width: calc(100% - 40px - 1.5rem);
    }
  }

  .sample-messages {
    height: 262px;
    overflow: auto;
    overflow-x: hidden;

    .list-group-item {
      text-align: left;

      & > div {
        max-height: 52px;
        overflow: hidden;
      }
    }
  }

  .live-input-in {
    border-bottom: thin solid #edeef0;
    position: relative;
    margin: 0 12px;

    .live-input-textarea {
      // width: calc(100% - 40px);
      width: 100%;
      border: none;
      background: transparent;
      // background: #fc0;
      margin: 0;
      resize: none;

      // padding: .5em 0 0 0;
      // max-height: 6em;

      padding: 1.4em 0 0 0;
      max-height: 12.2em;

      // font-size: .92rem;

      &[readonly] {
        color: #cdcdcd;
      }
    }

    .window-listing-sample-msgs {
      position: absolute;
      left: 1.2rem;
      bottom: 0.82rem;
      background: #fff;
      max-width: 320px;
      min-width: 100px;
      overflow: auto;
      overflow-x: hidden;
      max-height: 300px;
      display: none;

      &.show {
        display: block;
      }

      .notfound {
        font-size: 10pt;
      }
    }

    .list-group-item {
      padding: 0;
      font-size: 8pt;
      text-align: left;

      & > strong,
      & .sample-item,
      & > div > strong {
        padding: 0.35rem;
        display: block;
      }

      .sample-dones {
        position: relative;
        padding: 0.35rem;
        padding-top: 0;

        &::after {
          position: absolute;
          left: -5%;
          bottom: 0;
          content: '';
          height: 10px;
          width: 110%;
          box-shadow: 5px -5px 6px 0 rgba(255, 255, 255, 0.5) inset;
        }
      }

      .sample-item {
        width: 92px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #c0c0c0;
      }
    }

    .filter-msgs {
      .input-group-prepend {
        & > .input-group-text {
          background: transparent;
        }
      }
    }

    .new-sample {
      margin: 0 !important;

      * {
        font-size: 9pt !important;
      }

      textarea {
        min-height: 140px;
      }

      & > :first-child {
        padding: 0;
      }

      & > :last-child {
        max-height: 300px;
        overflow: auto;
        overflow-x: hidden;
      }

      .form-check-label {
        width: 160px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .form-check {
        & > input,
        & > label {
          vertical-align: middle;
        }

        & > label {
          margin-top: 0.1rem;
        }
      }

      .form-footer {
        & > :first-child {
          padding-right: 0.3rem !important;
        }

        & > :last-child {
          padding-left: 0.3rem !important;
        }
      }
    }
  }

  ::v-deep .emojis .popup-box-container button > span {
    display: block;
    height: 25px;
  }

  .live-templates,
  ::v-deep .emojis .popup-box-container button {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
    width: 40px;
    height: 45px;

    i {
      font-size: 18pt;
      color: #c1c7cd;
    }

    @media (max-width: 480px) {
      width: 22px;

      i {
        font-size: 12pt;
      }
    }
  }
}

/*
  .live-enter {
    float: right;
    height: 62px;
    width: 62px;
  }

  ::v-deep .emojis {
    float: left;
  }

  .live-templates, ::v-deep .emojis .popup-box-container button {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
    float: left;
    width: 48px;
    height: 62px;

    i {
      font-size: 18pt;
      color: #c1c7cd;
    }

    @media (max-width: 480px) {
      width: 22px;

      i {
        font-size: 12pt;
      }
    }
  }
}*/

.live-inner-header {
  border-bottom-width: thin;
  position: relative;
  height: 72px;
  min-height: 72px;

  .material-icons-outlined {
    color: #752de6 !important;
    font-size: 1.2rem;
  }

  .live-status {
    font-size: 7pt;
    font-weight: bold;
    vertical-align: middle;
  }

  .live-back {
    font-size: 14pt;
    float: left;
    width: 54px;
    height: 100%;
    padding-top: 10px;
    background-color: transparent;
    border: none;
    outline: none;

    &:hover {
      background-color: #fcfcfc;
    }

    .material-icons-outlined {
      font-size: 1.8rem;
    }

    @media (min-width: 801px) {
      // display: none !important;
    }
  }

  & > .live-photo {
    margin: 12px 10px 0 0;
    float: left;
    height: 48px;
    width: 48px;
    position: relative;
    border-radius: 0;
    background: transparent;

    .live-channel {
      position: absolute;
      right: -2px;
      top: -2px;
      font-size: 0.72rem;
      height: 16px;
      width: 16px;
      background: #fff;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        color: #752de6;
      }
    }

    button {
      background: #dfdfdf;
      border: none;
      border-radius: 48px;
      float: left;
      height: 100%;
      width: 100%;
      font-size: 12pt;
      padding: 0;
      overflow: hidden;
      border-radius: 24px;
    }

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  .live-header-info {
    padding-top: 8px;
    width: calc(100% - 410px);
    font-size: 12pt;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    float: left;
  }

  .live-header-name {
    font-weight: bold;

    .sub {
      margin-right: 5px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.is-manager {
  .live-header-info {
    width: calc(100% - 260px);
  }
}

.live-history-header {
  text-align: right;
  padding: 0.5em;
  border: solid #f7d85c;
  border-width: thin 0;
  background: #ffefad;
  font-size: 9pt;

  button {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    border: none;
    padding: 2px 10px;
    margin-left: 6px;
    transition: background-color 0.3s ease;
    vertical-align: middle;

    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }
}

.live-header-tools {
  padding: 21px 5px 0 5px;
  float: right;
  // width: 135px;
  width: 300px;
  text-align: right;

  @media (max-width: 920px) {
    display: none;
  }

  &::v-deep button:not(.btn-common),
  .menu-item {
    border: none !important;
    padding: 0 !important;
    border-radius: 50%;
    height: 36px !important;
    width: 36px !important;
    margin-left: 5px;
    vertical-align: middle;
  }

  &::v-deep .dropdown-menu {
    /*
    right: auto !important;
    left: 0 !important;
    top: 0 !important;
    */
    right: 0 !important;
    left: auto !important;
    top: 36px !important;
    transform: none !important;
  }

  .menu-item {
    display: inline-block;

    &::v-deep .dropdown {
      z-index: 1000;

      &,
      button:not(.btn-common) {
        color: #788db4 !important;
        margin: 0 !important;
      }

      button:not(.btn-common) {
        box-shadow: none !important;
        background: transparent !important;
        border: none;
        padding: 8px;
        width: 100%;

        &::after {
          display: none;
        }

        &:hover,
        &:active,
        &:focus {
          box-shadow: none !important;
          background: #fafafa !important;
        }
      }
    }
  }

  button:not(.btn-common)::v-deep {
    box-shadow: none !important;
    background: transparent !important;

    &:hover,
    &:active,
    &:focus {
      box-shadow: none !important;
      background: #fafafa !important;
    }
  }
}

.live-header-tools-m {
  display: none;
  width: 20%;
  float: right;
  margin-top: 22px;
  text-align: center;

  @media (max-width: 920px) {
    display: block;
  }
}

.live-inner-input {
  border-top-width: thin;
}

.live-transcript {
  padding: 1.5em;
}

.live-message {
  font-size: 10pt;
  min-width: 240px;
  margin-bottom: 35px;

  .live-agent {
    position: absolute;
    right: -10px;
    top: -10px;
    color: #fff;
    font-size: 7pt;
    text-transform: uppercase;
    padding: 0.5em !important;
    line-height: 1 !important;

    &.finished {
      background: #f00 !important;
    }
  }

  .live-message-box {
    position: relative;
    min-width: 200px;
    max-width: 60%;
    float: left;
    z-index: 1;

    .icon-fail {
      font-size: 8pt;
      color: #fff;
    }

    .live-message-source {
      display: none;
      position: absolute;
      right: 0;
      top: 0;
      padding: 4px 2px 20px 2px;
      font-size: 10pt;

      i {
        vertical-align: middle;
        margin-right: 2px;
      }
    }
  }

  .live-message-inner::before {
    background: #d6dadd;
    position: absolute;
    bottom: 10px;
    left: -5px;
    z-index: -1;
    content: '';
    height: 8px;
    width: 8px;
    transform: rotate(45deg);
  }

  &.me,
  &.automatic {
    .live-message-inner::before {
      left: auto;
      right: -5px;
    }
  }

  .live-message-content {
    overflow: auto;
    overflow-wrap: break-word;
    // word-break: break-all;
    color: #111b21;
    font-weight: 400;
  }

  // &.me .live-message-content {
  //   color: #fff;
  // }

  .live-message-content::v-deep {
    code {
      overflow-wrap: break-word;
      white-space: pre-wrap;
      color: inherit;
    }

    [data-interactive] {
      display: inline-block;
      position: relative;
      font-weight: 400;

      & > div {
        position: absolute;
        right: -45%;
        top: -82%;
        opacity: 0;
        transition: 0.2s all ease-out;

        & > button {
          box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.1);
          border-radius: 0.1rem;
          border: thin solid #c1c1c1;
          background: #fff;
          color: #c1c1c1;
        }
      }

      &:hover > div {
        opacity: 1;
      }
    }
  }

  .live-message-inner {
    position: relative;
    border: 2px solid #d6dadd !important;
    background: #f5f5f5;
    // padding: 14px 14px 32px 14px;
    padding: 14px;
    border-radius: 0.24em;
    letter-spacing: normal !important;

    .live-message-opts {
      position: absolute;
      right: 10px;
      top: 10px;

      &::v-deep .dropdown-toggle {
        visibility: hidden !important;
        background: transparent !important;
        padding: 0.1em 0.4em;
        height: auto;
        line-height: 1;
      }
    }

    &:hover .live-message-opts {
      &::v-deep .dropdown-toggle {
        visibility: visible !important;
        background: transparent !important;
        padding: 0.1em 0.4em;
        height: auto;
        line-height: 1;
      }
    }

    & > picture {
      position: absolute;
      right: -10px;
      top: -10px;
      color: #fff;
      background: #cfcfcf;
      width: 24px;
      height: 24px;
      border-radius: 12px;
      overflow: hidden;
      margin-right: 4px;
      pointer-events: none;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    & > strong {
      display: none;
      // display: block;
      padding-bottom: 0.4em;
    }

    .live-message-details {
      position: absolute;
      right: 0;
      bottom: -25px;
      font-size: 80%;
    }

    .live-message-time {
      opacity: 0.7;
      margin-right: 5px;
    }
  }

  // &:not(.me) .live-message-inner {
  //   border-top-left-radius: 0;
  // }

  &.another-agent .live-message-inner {
    // background: #f5eaf9 !important;
    border-color: #f5eaf9 !important;

    &::before {
      background: #f5eaf9 !important;
    }
  }

  &.place-offline .live-message-inner {
    // background: #f5eaf9 !important;
    border-color: #f5eaf9 !important;

    &::before {
      background: #f5eaf9 !important;
    }
  }

  &.automatic .live-message-inner {
    // background: #ffedc7 !important;
    border-color: #ffedc7 !important;

    &::before {
      background: #ffedc7 !important;
    }
  }

  &.me .live-message-inner {
    // background: #752de6 !important;
    // border: none !important;
    // color: #fff;
    border-color: #752de6 !important;

    &::before {
      background: #752de6 !important;
    }
  }

  &.fail {
    .live-message-inner {
      border: none !important;
      background: var(--danger) !important;
      color: #fff;
    }
  }

  &.deleted {
    .live-message-content {
      color: #cfcfcf !important;

      .live-message-text {
        font-style: italic;
      }
    }
  }

  &.me .live-message-box,
  &.automatic .live-message-box {
    float: right;

    .live-message-source {
      text-align: right;
    }
  }

  &::after {
    content: '';
    display: block;
    clear: both;
  }

  .live-message-attachments {
    video,
    img,
    audio {
      max-height: 320px;
      max-width: 100%;
    }
  }

  &.upload {
    .live-message-box {
      .live-message-inner {
        padding-bottom: 14px;
        white-space: nowrap;

        > span {
          margin-right: 4px;
        }
      }

      text-align: center;
      min-width: 1px;
      max-width: 60%;
    }
  }
}

.toggle-meta {
  @media (min-width: 1231px) {
    display: none;
  }
}

.live-input-count {
  position: absolute;
  right: 0;
  bottom: -17px;
  font-size: 7pt;

  .exceed {
    font-weight: bold;
    color: #f00;
  }
}

.live-input-btn {
  cursor: pointer;
  padding: 0;
  float: right;
  width: 40px;
  margin-top: 2px;
  height: 40px;
  border: none;
  background: transparent;
  font-size: 12pt;
  transition: 0.3s background ease;
  outline: none;
  background: transparent;
  border-radius: 0.15rem;

  &:hover {
    background-color: #f4f4f4;
  }

  &.live-enter,
  &.live-speak {
    .material-icons-outlined {
      color: #752de6 !important;
    }
  }

  /*
  &:enabled, .live-speak {
    background: #752de6;
  }
  */
}

.live-input-btn,
.btn-create-sample-msg,
.live-header-tools::v-deep button {
  &:not(:enabled) {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

/*
#live-attach {
  float: left;
}
*/

#live-attach-input {
  display: none;
}

.live-external {
  position: relative;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  display: block;
  color: #fff;
  overflow: hidden;

  & > i {
    color: inherit;
    text-align: center;
    vertical-align: middle;
    width: 62px;
    font-size: 42pt;
    padding: 8px;
    display: inline-block;
  }

  .live-attach-name {
    vertical-align: middle;
    padding: 3px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: calc(100% - 70px);
    display: inline-block;
    text-align: right;
    direction: rtl;
  }

  .live-attach-type {
    background: rgba(0, 0, 0, 0.15);
    padding: 3px 6px;
    clear: both;
  }
}

#live-attach ::v-deep {
  button {
    border: none !important;
    background: transparent !important;
    width: 40px !important;
    padding: 0 !important;
    height: 45px !important;
    font-size: 14pt;
    box-shadow: none !important;

    &:hover,
    &:active {
      background: #fcfcfc !important;
    }
  }

  ul {
    top: auto !important;
    left: 0 !important;
    right: auto !important;
    bottom: 50px !important;
  }

  .dropdown-toggle::after {
    display: none;
  }

  @media (max-width: 480px) {
    button {
      height: 58px !important;
      font-size: 14pt;
      padding: 0 15px;
    }

    ul {
      bottom: 38px !important;
    }
  }
}

.icon-live {
  font-size: 18pt;
  color: #c1c7cd;
  float: left;
  margin-top: 18px;
}

.fab-item-image {
  text-align: center !important;
}

.fab-item-image i {
  display: block;
  color: rgb(140, 140, 140);
  text-align: center;
  margin-top: 8px;
}

.up-spinner {
  animation: rotation 0.32s linear infinite;
  transform-origin: 0.72rem 0.68rem;
  height: 1.4rem;
  width: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.live-conversation::v-deep {
  .cke_top,
  .cke_inner {
    background: transparent !important;
  }

  .cke {
    border: none !important;
  }
}
.card {
  padding: 0px 26px;
  margin-bottom: 0;

  .card-body {
    padding-left: 0;
    padding-right: 0;

    .chat-template-wrapper {
      border: 1px solid #E4E7EC;
      max-height: 188px;
      overflow-y: auto;
    }
  }

  .card-footer {
    border-top: 2px solid #E4E7EC;
    padding-left: 0;
    padding-right: 0;

    .btn.tertiary {
      padding-left: 0;
      padding-right: 0;
    }

    .vr {
      display: inline;
      border: 1px solid #E4E7EC;
      margin: 0 20px;
    }
  }
}

.channels {
  gap: 27px;
  display: flex;

  &.justify-content-center {
    text-align: center;
  }

  .d-inline-block {
    box-shadow: 0px 3px 36px 6px #6B23DC29;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    padding: 7px;
    text-align: center;

    i {
      font-size: 34px;
      line-height: 1;
      color: #667085;

      svg {
        fill: #667085;
      }
    }
  }
}

.loading {
  position: absolute;
  background: rgba(255, 255, 255, 0.4);
  width: 100%;
  height: 100%;
}
.alert-error {
  width: 100%;
  margin-right: 10px;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.btn-enable-channel {
    background-color: var(--clr-yup-purple) !important;
    border-color: var(--clr-yup-purple) !important;
    color: #fff !important;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    font-weight: 400;
}

.btn-enable-channel:focus {
    background-color: #0E1421 !important;
    border-color: #0E1421 !important;
    color: rgba(255, 255, 255, 0.85) !important;
}
.btn-enable-channel {
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    user-select: none;
    border: 1px solid transparent;
    padding: 8px 20px;
    font-size: .875rem;
    border-radius: .25rem;
    transition: all .2s ease;
    height: 38px;
    vertical-align: middle;
    font-weight: 300;
    cursor: pointer;
}
.btn-enable-channel{
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.btn-enable-channel {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    height: 46px;
    padding-top: 10px;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
.footer-message {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
